// components/PitchDeck/09_ImpactSDG.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function ImpactSDG() {
    return (
        <div className="min-h-screen flex items-center bg-white py-20">
            <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-12">
                    Real Impact
                </h2>
                <p className="text-3xl font-semibold mb-12">
                    Aligned with UN SDGs
                </p>
                <div className="grid md:grid-cols-3 gap-8">
                    <div className="bg-green-50 p-8 rounded-2xl">
                        <h3 className="text-2xl font-bold mb-4">SDG 8</h3>
                        <p className="text-xl">Decent Work & Economic Growth</p>
                        <p className="text-lg mt-4">Efficiency gains → job creation (200–500 indirect hires at 100 customers)</p>
                    </div>
                    <div className="bg-green-50 p-8 rounded-2xl">
                        <h3 className="text-2xl font-bold mb-4">SDG 9</h3>
                        <p className="text-xl">Industry, Innovation & Infrastructure</p>
                        <p className="text-lg mt-4">AI automation + digital tools for SMEs</p>
                    </div>
                    <div className="bg-green-50 p-8 rounded-2xl">
                        <h3 className="text-2xl font-bold mb-4">SDG 16</h3>
                        <p className="text-xl">Peace, Justice & Strong Institutions</p>
                        <p className="text-lg mt-4">Better tax compliance → stronger revenue collection & transparency</p>
                    </div>
                </div>
                <p className="mt-16 text-2xl font-bold text-gray-900">
                    First customer: Recovered ₦10M+ in overpayments/bad debts in one month — hired extra cashier & storekeeper.
                </p>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-700/40 rounded-full text-gray-700 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="/pitch/the-ask">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}